import { apiService } from "./apiService";
import { By } from "../types/visualSearch";

const VisualSearchService = {
  bingSearch: async (image: string, by: By) => {
    return apiService.post("/api/visual-search/bing/search", { image, by });
  },
  pimeyesUpload: async (image: string, by: By) => {
    const response = await apiService.post("/api/visual-search/pimeyes/upload", { image, by });
    return response.data.payload;
  },
  pimeyesSearch: async (faces: string[]) => {
    const response = await apiService.post("/api/visual-search/pimeyes/search", { faces });
    return response.data.payload;
  },
  tinEyeSearch: async (image: string, offset, by: By) => {
    return apiService.post("/api/visual-search/tineye/search", { image, offset, by });
  }
};

export default VisualSearchService;
